"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientsList = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const filter_header_1 = require("client/components/filter-header");
// import { NotifyIcon } from "client/components/icons";
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const button_1 = require("client/components/material/button");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const floating_page_1 = require("client/components/page/floating-page");
const progress_bar_1 = require("client/components/progress-bar");
const router_1 = require("client/components/router");
const multi_select_1 = require("client/components/ui/multi-select");
const store_1 = require("client/modules/app-settings/store");
const store_2 = require("client/modules/patients/store");
const store_3 = require("client/modules/sites/modules/sites-list/store");
const store_4 = require("client/modules/users/store");
const Add_1 = require("material-ui-icons/Add");
const Publish_1 = require("material-ui-icons/Publish");
// import { WarningIcon } from "client/components/icons";
const Warning_1 = require("material-ui-icons/Warning");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const React = require("react");
const react_1 = require("react");
const ReactTooltip = require("react-tooltip");
const app_settings_1 = require("shared/app-settings");
const capitalize_string_1 = require("shared/util/capitalize-string");
const throttle_debounce_1 = require("throttle-debounce");
require("./patients-list.less");
const text_field_small_1 = require("client/components/material/text-field/text-field-small");
const columns = [
    {
        center: false,
        id: "patient.id",
        numeric: false,
        label: "Patient ID"
    },
    {
        center: false,
        id: "patient.lastName",
        numeric: false,
        label: "Patient"
    },
    {
        center: false,
        id: "patient.birthDate",
        numeric: false,
        label: "Date of Birth"
    },
    {
        center: false,
        id: "sites.displayName",
        numeric: false,
        label: "Pharmacy"
    },
    {
        center: false,
        id: "NO_ACTION",
        numeric: false,
        label: "Scheduled Appointment",
        sortable: false
    },
    {
        center: false,
        id: "NO_ACTION",
        numeric: false,
        label: "Next Refill Available",
        sortable: false
    },
    {
        center: false,
        id: "NO_ACTION",
        numeric: true,
        label: ""
    },
];
let PatientsList = class PatientsList extends react_1.Component {
    constructor() {
        super(...arguments);
        this.order = "ASC";
        this.orderBy = "patient.lastName";
        this.showUpload = false;
        this.showDeleted = false;
        this.filterText = "";
        this.refills = {};
        this.bulkE1 = false;
        this.selectedPatients = [];
        this.allPatients = [];
        this.showPercent = false;
        this.patientSelectFilterText = "";
        this.daysPrior = 0;
        // C-097 Patients 
        this.page = 1;
        this.limit = 25;
        this.totalPages = 1;
        this.loadPatients = throttle_debounce_1.debounce(200, async () => {
            store_2.patientsStore.loadPatients({
                count: 100,
                order: this.order,
                search: this.filterText,
                sort: this.orderBy,
                showDeleted: this.showDeleted.toString(),
                start: 0,
                readPatients: store_4.usersStore.permissions.ReadPatients,
                page: this.page,
                limit: this.limit // C-097 Patients 
            });
        });
        this.onHandleClickAddPatient = () => {
            router_1.RouteManager.transitionTo("/patients/0");
        };
        this.onMouseEnter = () => {
            this.showUpload = true;
        };
        this.onMouseLeave = () => {
            this.showUpload = false;
        };
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            this.loadPatients();
        };
        this.onCallback = (value) => {
            this.filterText = value;
            this.loadPatients();
        };
        this.onChangePatientFilterText = (value) => {
            this.patientSelectFilterText = value;
        };
        this.initializePatientsRefills = (patients) => {
            for (const patient of patients) {
                // console.log(patient, "AAA");
                /** Orders made before the current time. */
                const processedOrders = patient.orders.filter(order => moment(order.createDate).isBefore(new Date()));
                // console.log("processedOrders", processedOrders);
                // Loop through patient orders to initialize refills timestamp
                for (const order of processedOrders) {
                    const claims = order.claims.filter((claim) => claim.refills > parseInt(claim.fillNumber, 10) &&
                        (claim.status === "5dispensed" || claim.status === "0refill"));
                    // console.log("claims 5dispensed || 0refill ", claims);
                    if (claims.length > 0) {
                        const nextRefill = claims.length < 2 ? claims[0] : this.getSoonestClaims(claims);
                        const refillTime = moment(nextRefill.date)
                            .add(nextRefill.daysSupply, "days")
                            .add(nextRefill.delayRefill, "days");
                        const timeString = refillTime.isBefore(new Date())
                            ? "NOW"
                            : `${refillTime.format("MM/DD/YYYY hh:mm A")}`;
                        this.refills[patient.id] = timeString;
                    }
                }
            }
        };
        this.renderTable = () => {
            const { patients: { value: patients = [] } } = store_2.patientsStore;
            console.time("initrefill");
            this.initializePatientsRefills(patients);
            console.timeEnd("initrefill");
            // console.log("this.refills", this.refills);
            return (React.createElement("div", { className: "patients__list" },
                React.createElement(list_1.MaterialList, { columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: patients, renderRow: this.renderTableRow, resizableheader: true, customClass: "custom-material-list__patients-list" })));
        };
        this.getSoonestClaims = (claims) => claims.reduce((pre, cur) => {
            const preRefillDate = moment(pre.date);
            const curRefillDate = moment(cur.date);
            preRefillDate.add(pre.daysSupply, "days");
            preRefillDate.add(pre.delayRefill, "days");
            curRefillDate.add(cur.daysSupply, "days");
            curRefillDate.add(cur.delayRefill, "days");
            return moment(preRefillDate).isBefore(curRefillDate) ? pre : cur;
        }, claims[0]);
        this.renderTableRow = (row, index) => {
            const disabledAccent = row.deletedAt ? "deleted-patient-accent" : "";
            const patient = row.id;
            const displayName = row.lastName && row.firstName
                ? `${row.lastName}, ${row.firstName}`
                : `${row.firstName} ${row.lastName}`;
            const pharmacyName = row.sites ? row.sites[0].displayName : "";
            const birthday = moment(row.birthDate)
                .format("MM/DD/YYYY")
                .replace("Invalid date", "");
            /** Orders made after the current time. */
            const futureOrders = row.orders.filter(order => moment(order.createDate).isAfter(new Date()));
            // /** Orders made before the current time. */
            // const processedOrders = row.orders.filter(order =>
            //   moment(order.createDate).isBefore(new Date())
            // );
            /**
             * 1. Loop through every previous order and check to see if that order has
             * claims with refills. If it does, we then compare each one and keep
             * the soonest date.
             *
             * 2. Add the daysSupply and refillDelay to the claim date; this should match
             * the same time that will trigger a "Refill Due" change from cron.
             *
             * 3. If the refill is already due, we set the flag to "NOW", otherwise
             * we set it to the future refill due date.
             */
            // processedOrders.forEach(async order => {
            //   await patientsStore.futureRefills(order.id).then(e => {
            //     if (e.length > 0) {
            //       const nextRefill =
            //         e.length < 2
            //           ? e[0]
            //           : e.reduce((pre: any, cur: any) => {
            //               const preRefillDate = moment(pre.date);
            //               const curRefillDate = moment(cur.date);
            //               preRefillDate.add(pre.daysSupply, "days");
            //               preRefillDate.add(pre.delayRefill, "days");
            //               curRefillDate.add(cur.daysSupply, "days");
            //               curRefillDate.add(cur.delayRefill, "days");
            //               return moment(preRefillDate).isBefore(curRefillDate)
            //                 ? pre
            //                 : cur;
            //             }, e[0]);
            //       const refillTime = moment(nextRefill.date)
            //         .add(nextRefill.daysSupply, "days")
            //         .add(nextRefill.refillDelay, "days");
            //       const timeString = refillTime.isBefore(new Date())
            //         ? "NOW"
            //         : `${refillTime.format("MM/DD/YYYY hh:mm A")}`;
            //       this.refills[patient] = timeString;
            //     }
            //   });
            // });
            const nextAppt = futureOrders.reduce((prev, curr) => moment(prev.createDate).isBefore(curr.createDate) ? prev : curr, futureOrders[0]);
            const time = nextAppt && nextAppt.site && nextAppt.site.timezone !== undefined
                ? moment.tz(nextAppt.createDate, nextAppt.site.timezone)
                : "";
            const today = moment().startOf("day");
            const uploadswithExpdate = row.uploads.filter(upload => upload.expDate !== null);
            let assetExpired = false;
            for (const item of uploadswithExpdate) {
                const expDate = moment(item.expDate);
                assetExpired = today.isSameOrAfter(expDate);
                if (assetExpired) {
                    break;
                }
            }
            let assetExpiring = false;
            for (const item of uploadswithExpdate) {
                const expDate = moment(item.expDate);
                const alertDateAsset = moment(item.expDate)
                    .subtract(this.daysPrior, "days")
                    .startOf("day")
                    .toString();
                assetExpiring = today.isBetween(alertDateAsset, expDate);
                if (assetExpiring) {
                    break;
                }
            }
            // const missingRequiredAssetsforProvArray =
            //   this.missingRequiredAssets &&
            //   this.missingRequiredAssets.filter((asset: any) => asset.id === row.id);
            // const rowUploadsArray = row.uploads.map(
            //   (upload: any) => upload.connectAssetId
            // );
            //  if rowUploadsArray contains the ids or the assetsArray then it should not have a warning, and missing will be empty
            // const missing =
            //   missingRequiredAssetsforProvArray &&
            //   missingRequiredAssetsforProvArray.length &&
            //   missingRequiredAssetsforProvArray[0].assetsArray &&
            //   missingRequiredAssetsforProvArray[0].assetsArray.length &&
            //   missingRequiredAssetsforProvArray[0].assetsArray.filter(
            //     (num: any) => num && !rowUploadsArray.includes(num.id)
            //   );
            // let missingRequired = false;
            // if (
            //   missingRequiredAssetsforProvArray &&
            //   missingRequiredAssetsforProvArray.length &&
            //   missingRequiredAssetsforProvArray[0].assetsArray &&
            //   missingRequiredAssetsforProvArray[0].assetsArray.length > 0 &&
            //   missing &&
            //   missing.length > 0
            // ) {
            //   missingRequired = true;
            // }
            const patientName = displayName;
            const siteName = pharmacyName;
            return (
            // <MaterialTableRow
            //   key={index}
            //   to={`patients/${patient}`}
            //   classes={{ root: disabledAccent }}
            // >
            //   {/* <MaterialCheckbox // Will convert droptdown to this later.
            //     checked={this.checkedBoxes[child.id] || false}
            //     label=""
            //     onAction={() => this.handleCheckChild(child)}
            //   /> */}
            //   <TableCell>{displayName}</TableCell>
            //   <TableCell>{birthday}</TableCell>
            //   <TableCell>{pharmacyName}</TableCell>
            //   <TableCell>
            //     {time && `${time.format("MM/DD/YYYY hh:mm A")} (${time.format("z")})`}
            //   </TableCell>
            //   <TableCell>{this.refills[patient] || ""}</TableCell>
            //   <TableCell
            //     data-tip={
            //       row.missingInsurance
            //         ? "Patient is missing insurance information"
            //         : ""
            //     }
            //   >
            //     {row.missingInsurance && <WarningIcon fill="#eeb20d" />}
            //   </TableCell>
            //   <TableCell
            //     data-tip={
            //       assetExpired
            //         ? "One or more assets expired."
            //         : assetExpiring
            //         ? "One or more assets are expiring soon."
            //         : ""
            //     }
            //   >
            //     {(assetExpiring || assetExpired) && <WarningIcon fill="#eeb20d" />}
            //   </TableCell>
            // </MaterialTableRow>
            React.createElement(list_item_1.MaterialListItem, { key: index, to: `patients/${patient}`, classes: { root: disabledAccent } },
                React.createElement(list_item_text_1.MaterialListItemText, { primary: patient }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(patientName) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: birthday }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(siteName) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: time
                        ? `${time.format("MM/DD/YYYY hh:mm A")} (${time.format("z")})`
                        : "" }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: this.refills[patient] || "" }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: row.missingInsurance ? (React.createElement(Warning_1.default, { className: "warning-quantity--icon", "data-place": "right", "data-tip": "Patient is missing insurance information", "data-for": "warning-icon", fill: "#eeb20d" })) : null }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: assetExpiring ? (React.createElement(Warning_1.default, { className: "warning-quantity--icon", "data-place": "right", "data-tip": "One or more assets are expiring soon.", "data-for": "warning-icon", fill: "#eeb20d" })) : assetExpired ? (React.createElement(Warning_1.default, { className: "warning-quantity--icon", "data-place": "right", "data-tip": "One or more assets expired.", "data-for": "warning-icon", fill: "#eeb20d" })) : null })));
        };
        this.handleToggle = () => {
            this.showDeleted = !this.showDeleted;
            this.loadPatients();
        };
        // C-097 handle pagination input
        this.handleKeyDown = () => {
            if (this.page === Number(""))
                return;
            (this.page !== store_2.patientsStore.currentPage) && this.loadPatients();
        };
    }
    get availablePatients() {
        // console.log("patientstore patient value is ", patientsStore.patients.value);
        // this.loadPatients();
        return store_2.patientsStore.patients.value
            ? store_2.patientsStore.patients.value
                .filter((patient) => !this.selectedPatients.find((labelSelect) => labelSelect.id === patient.id))
                .filter((patient) => {
                // console.log("patient is ", patient);
                const fullName = `${patient.firstName} ${patient.lastName}`;
                const fullNameReverse = `${patient.lastName} ${patient.firstName}`;
                const matchName = fullName
                    .toLowerCase()
                    .includes(this.patientSelectFilterText.toLowerCase());
                const matchNameReverse = fullNameReverse
                    .toLowerCase()
                    .includes(this.patientSelectFilterText.toLowerCase());
                return matchName || matchNameReverse;
            })
                .map((patient, i) => ({
                id: patient.id,
                label: `${patient.firstName} ${patient.lastName}`,
                value: patient.id.toString(),
                data: patient
            }))
            : [];
    }
    componentWillMount() {
        ReactTooltip.rebuild();
        // sitesListStore.loadSites();
        store_3.sitesListStore.loadSitesNoRelation();
    }
    async componentDidMount() {
        await this.loadPatients();
        // await patientsStore.loadPatients();
        const daysSetting = await store_1.appSettingsStore.readSettings(app_settings_1.AppOption.DaysPriorProvExpLicense);
        this.daysPrior = Number(daysSetting.value);
        // C-097 Patients 
        this.totalPages = store_2.patientsStore.totalProviderPage;
        // const patients = patientsStore.patients.value;
        // const missingRequiredAssetsArray = await providersStore.getMissingRequiredAssets(
        //   patients,
        //   "patient"
        // );
        // this.missingRequiredAssets = missingRequiredAssetsArray
        //   ? Array.from(missingRequiredAssetsArray)
        //   : [];
        ReactTooltip.rebuild();
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
        if (store_2.patientsStore.massPercent === 100) {
            setTimeout(() => {
                this.showPercent = false;
                store_2.patientsStore.massPercent = 0;
            }, 2000);
        }
    }
    componentWillUnmount() {
        ReactTooltip.hide();
    }
    render() {
        ReactTooltip.rebuild();
        return (React.createElement("div", { className: "patients patients-wrapper" },
            React.createElement(ReactTooltip, { id: "warning-icon", className: "tooltip", effect: "solid", place: "left", "data-type": "warning", multiline: true }),
            store_4.usersStore.permissions.ReadPatient ||
                store_4.usersStore.permissions.ReadPatients ? (React.createElement(React.Fragment, null,
                React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                    React.createElement("div", { className: "patients__title-wrapper" },
                        React.createElement(kpi_title_1.KpiTitle, { label: "Patients", subLabel: " " }),
                        store_4.usersStore.permissions.CreatePatient && (React.createElement("div", { className: "floating-buttons", onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, tabIndex: 0 },
                            React.createElement(button_1.MaterialButton, { fab: true, secondary: true, className: "import-patient-btn", to: "/patients/import" },
                                React.createElement(Publish_1.default, null)),
                            React.createElement(button_1.MaterialButton, { fab: true, primary: true, className: "add-patient-btn", to: "/patients/0", onMouseEnter: this.onMouseEnter },
                                React.createElement(Add_1.default, null)))))),
                React.createElement(floating_page_1.FloatingPage, null,
                    this.renderMain(),
                    this.bulkE1 && this.renderE1(),
                    this.showPercent && this.renderPercent()))) : (store_4.usersStore.showLock())));
    }
    renderE1() {
        const selection = (React.createElement(multi_select_1.UiMultiSelect, { className: "patients", label: "Patients", required: true, onSearch: this.onChangePatientFilterText, options: this.availablePatients, values: this.selectedPatients, onChange: (values) => {
                this.selectedPatients = values;
                // console.log("this.selectedPatients is ", toJS(this.selectedPatients));
            } }));
        return (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Submit", cancelText: "Cancel", addinModal: selection, message: `<p>Please select the patients you wish to perform an E1 claim on, then click submit.</p>`, onCancel: () => (this.bulkE1 = false), onConfirm: () => this.handleSubmitE1(), title: `Bulk Patient E1 Submission` }));
    }
    renderMain() {
        return React.createElement("div", { className: "patients__main" }, this.renderPatients());
    }
    renderPercent() {
        const percent = store_2.patientsStore.massPercent;
        const message = percent !== 100 ? `Executing E1s: ${percent}%` : "Complete!";
        return (React.createElement(progress_bar_1.ProgressBarContainer, { className: "progress-bar-custom" +
                (store_2.patientsStore.massPercent === 100
                    ? " progress-bar-custom--complete"
                    : ""), percentage: store_2.patientsStore.massPercent, title: "Filing E1 Claims", message: message }));
    }
    handleSubmitE1() {
        this.bulkE1 = false;
        if (this.selectedPatients.length > 0) {
            this.showPercent = true;
            const patientsArray = this.selectedPatients.map((patient) => patient.data);
            // console.log("patients array ", patientsArray);
            store_2.patientsStore.massInsuranceRequest(patientsArray);
        }
    }
    renderPatients() {
        return (React.createElement("div", { className: "patients__data" },
            (store_4.usersStore.permissions.CreatePatient && (React.createElement(filter_header_1.FilterHeader, { label: "Search", switchChecked: this.showDeleted, switchLabel: "Show Deleted Patients", title: "Patients", withSwitch: true, callBack: this.onCallback, filterText: this.filterText, handleToggle: this.handleToggle }))) || (React.createElement(filter_header_1.FilterHeader, { label: "Search", title: "Patients", callBack: this.onCallback, filterText: this.filterText })),
            this.renderTable(),
            React.createElement("div", { className: "pagination-container-header" },
                React.createElement("button", { className: "btn-pagination", onClick: () => {
                        if (store_2.patientsStore.currentPage === 1)
                            return;
                        this.page--;
                        this.loadPatients();
                    } }, "Previous"),
                React.createElement("div", { className: "pagination-container" },
                    React.createElement("p", null, "Page"),
                    React.createElement("div", { style: { display: 'contents' } },
                        React.createElement("div", { className: "cstmPaginationInput-Wrapper" },
                            React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "pagination-input", autoFocus: true, type: "text", onChange: (e) => {
                                    const value = Number(e.target.value);
                                    if (value >= 1 && value <= store_2.patientsStore.totalProviderPage) {
                                        this.page = value;
                                    }
                                    else {
                                        if (e.target.value <= store_2.patientsStore.totalProviderPage) {
                                            this.page = value;
                                        }
                                        else {
                                            e.target.value = this.page;
                                        }
                                    }
                                }, onKeyDown: () => { }, onKeyDownEnterPress: this.handleKeyDown, value: this.page || "" })),
                        React.createElement("div", null, "of"),
                        React.createElement("div", null, store_2.patientsStore.totalProviderPage)),
                    React.createElement("select", { className: "pagination-input", onChange: (e) => {
                            this.limit = Number(e.target.value);
                            this.loadPatients();
                            this.page = 1;
                        }, defaultValue: this.limit },
                        React.createElement("option", { value: "5" }, "5 rows"),
                        React.createElement("option", { value: "10" }, "10 rows"),
                        React.createElement("option", { value: "25" }, "25 rows"),
                        React.createElement("option", { value: "50" }, "50 rows"),
                        React.createElement("option", { value: "100" }, "100 rows"))),
                React.createElement("button", { className: "btn-pagination1", onClick: () => {
                        if (store_2.patientsStore.patientsLoading && this.page === this.totalPages)
                            return;
                        this.page++;
                        this.loadPatients();
                    } }, "Next")),
            React.createElement(ReactTooltip, { effect: "solid", place: "left" })));
    }
};
__decorate([
    mobx_1.computed
], PatientsList.prototype, "availablePatients", null);
__decorate([
    mobx_1.observable
], PatientsList.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], PatientsList.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], PatientsList.prototype, "showUpload", void 0);
__decorate([
    mobx_1.observable
], PatientsList.prototype, "showDeleted", void 0);
__decorate([
    mobx_1.observable
], PatientsList.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], PatientsList.prototype, "refills", void 0);
__decorate([
    mobx_1.observable
], PatientsList.prototype, "bulkE1", void 0);
__decorate([
    mobx_1.observable
], PatientsList.prototype, "selectedPatients", void 0);
__decorate([
    mobx_1.observable
], PatientsList.prototype, "allPatients", void 0);
__decorate([
    mobx_1.observable
], PatientsList.prototype, "showPercent", void 0);
__decorate([
    mobx_1.observable
], PatientsList.prototype, "patientSelectFilterText", void 0);
__decorate([
    mobx_1.observable
], PatientsList.prototype, "daysPrior", void 0);
__decorate([
    mobx_1.observable
], PatientsList.prototype, "missingRequiredAssets", void 0);
__decorate([
    mobx_1.observable
], PatientsList.prototype, "page", void 0);
__decorate([
    mobx_1.observable
], PatientsList.prototype, "limit", void 0);
__decorate([
    mobx_1.observable
], PatientsList.prototype, "totalPages", void 0);
PatientsList = __decorate([
    mobx_react_1.observer
], PatientsList);
exports.PatientsList = PatientsList;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/patients/modules/patients-list/patients-list.tsx
// module id = 3824
// module chunks = 0